import React from 'react'

import { WebViewStoreContext } from '../store'

export const useWebViewStore = () => React.useContext(WebViewStoreContext)
